export default __webpack_public_path__ + "x2-symbol-of-a-letter-and-a-number-subscript.png";